import { Fragment } from "react";
import { getHighlightParts } from "../../utils/highlight";

interface HighlightWordProps {
  word: string;
  isExcerpt: boolean;
}

function HighlightWord({ word, isExcerpt }: HighlightWordProps) {
  return (
    <span className={isExcerpt ? "font-bold" : "font-bold text-neutral-900"}>
      {word}
    </span>
  );
}

interface HighlightedSectionProps {
  text?: string;
  highlight?: string;
  isExcerpt: boolean;
}

export default function HighlightedSection({
  text = "",
  highlight = "",
  isExcerpt,
}: HighlightedSectionProps) {
  let parts;
  const { parts: initialParts, highlightIndexes } = getHighlightParts({
    text,
    highlight,
  });
  parts = initialParts;

  if (isExcerpt && highlightIndexes?.[0]) {
    const startIdx = highlightIndexes[0].startIdx;
    if (startIdx > 50) {
      const trimmedText = "..." + text?.slice(startIdx - 20);
      const { parts: updatedParts } = getHighlightParts({
        text: trimmedText,
        highlight,
      });
      parts = updatedParts;
    }
  }

  return (
    <>
      {parts.map((part, idx) =>
        part.type === "highlight" ? (
          <Fragment key={idx}>
            <HighlightWord word={part.text} isExcerpt={isExcerpt} />
          </Fragment>
        ) : (
          <Fragment key={idx}>{part.text}</Fragment>
        ),
      )}
    </>
  );
}
